<template>
  <b-link class="nav-link favorite-action" :class="{'is-favorite': media.favorite}" @click="onToggleFavorite">
    <div class="icon-bg">
      <b-spinner label="Loading..." class="spin" size="sm" v-if="loading"/>
      <Icon name="heart" :width="iconWidth" v-else/>
    </div>
  </b-link>
</template>

<script>
import {mapActions} from "vuex";
import notificationAudio from '@/assets/audio/notification.mp3'

export default {
  name: "FavoriteAction",
  emits: ['toggle-favorite'],
  data() {
    return {
      loading: false,
      audio: new Audio(notificationAudio)
    }
  },
  props: {
    media: {
      type: Object,
      required: true
    },
    iconWidth: {
      required: false,
      type: Number,
      default: 26
    }
  },

  methods: {
    ...mapActions('galleries', ['toggleFavorite']),
    async onToggleFavorite() {
      this.loading = true
      this.$emit('toggle-favorite')
      await this.$nextTick()
      const isFavorite =await this.toggleFavorite(this.media)
      if(!isFavorite) await this.audio.play()
      this.loading = false
    }
  },
}
</script>


<style scoped>

</style>